<template>
   <section class="breadcrumbs-custom">
      <!-- <div class="parallax-container">
         <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs"></div>
         <div class="breadcrumbs-custom-body parallax-content context-dark">
         <div class="container">
               <h2 class="breadcrumbs-custom-title">Login</h2>
         </div>
         </div>
      </div> -->
      <div class="breadcrumbs-custom-footer">
         <div class="container">
         <ul class="breadcrumbs-custom-path">
               <li><router-link to="/">Home</router-link></li>            
               <li class="active">Login</li>
         </ul>
         </div>
      </div>
   </section>

   <section class="section section-xxl bg-default">
      <div class="container">
         <div class="row row-40 justify-content-center">         
            <div class="col-sm-10 col-md-6">
               <div class="inset-xl-right-50">
                  <h3>Login</h3>
                  <!-- <div class="group group-middle group-button-1"><a class="button button-google button-icon button-icon-left button-round" href="#"><span class="icon fa fa-google-plus"></span>Google+</a><a class="button button-twitter button-icon button-icon-left button-round" href="#"><span class="icon fa fa-twitter"></span>Twitter</a><a class="button button-facebook button-icon button-icon-left button-round" href="#"><span class="icon fa fa-facebook"></span>Facebook</a></div> -->
                  <!-- RD Mailform-->
                  <form @submit.prevent="submitForm" class="rd-form rd-mailform" novalidate="novalidate">
                  <div class="form-wrap" :class="{ 'has-error': v$.loginData.email.$error || store.isServeError && serverError.hasOwnProperty('email') }">
                     <input v-model="loginData.email" class="form-input form-control-has-validation" id="login-email" type="text" data-constraints="@Required"><span class="form-validation">The field is required.</span>
                     <label class="form-label rd-input-label" for="login-email">Email</label>
                     <span v-if="v$.loginData.email.$error" class="form-validation">
                        {{ emailErrorMsg }}
                     </span>
                     <span v-if="store.isServeError && serverError.hasOwnProperty('email')" class="form-validation">{{ serverError.email[0] }}</span>
                  </div>
                  <div class="form-wrap" :class="{ 'has-error': v$.loginData.password.$error || store.isServeError && serverError.hasOwnProperty('password') }" style="position: relative;">
                     <input v-model="loginData.password" class="form-input form-control-has-validation" id="login-password" :type="showPassword ? 'text' : 'password'" data-constraints="@Required" style="padding-right: 40px;"><span class="form-validation">The field is required.</span>
                     <label class="form-label rd-input-label" for="login-password">Password</label>
                     <span @click="showPassword = !showPassword" style="position: absolute; right: 15px; top: 15px; cursor: pointer; z-index: 10; font-size: 1.2em; color: #a0a0a0;">
                        <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                     </span>
                     <span v-if="v$.loginData.email.$error" class="form-validation">
                        The field is required
                     </span>
                     <span v-if="store.isServeError && serverError.hasOwnProperty('password')" class="form-validation">{{ serverError.password[0] }}</span>
                  </div>
                  <label class="">
                     <!-- <input name="input-checkbox-1" value="checkbox-1" type="checkbox" class="checkbox-custom"><span class="checkbox-custom-dummy"></span>Remember Me -->
                     <router-link to="/forgot-password">Forgot Password</router-link>
                  </label>
                  <div class="group-sm group-middle group-button-1">
                     <button class="button button-lg button-primary button-zakaria" type="submit" :disabled="isSubmitting">
                        <span v-if="isSubmitting">Signning in...</span>
                        <span v-else>Sign In</span>
                     </button>
                     <router-link class="button button-lg button-secondary button-zakaria" to="/register">Create an account</router-link>
                  </div>
                  <p v-if="errorMessage" class="text-danger mt-3">{{ errorMessage }}</p>
                  <p v-if="successMessage" class="text-success mt-3">{{ successMessage }}</p>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>
<script setup>
import { onMounted, computed, ref } from 'vue'
import { useHead } from '@unhead/vue'
import { useCartStore } from '@/stores/cart'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'

const cartStore = useCartStore()

const store = useAuthStore()
const { loginData, isSubmitting, successMessage, errorMessage, serverError } = storeToRefs(store)

const showPassword = ref(false)

useHead({
  title: 'CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Welcome to CakeGurus.',
    },
  ],
})

const rules = {
  loginData: {
    email: { required },
    password: { required},
  },
}

const v$ = useVuelidate(rules, { loginData })

const emailErrorMsg = computed(() => {
  if (!v$.value.loginData.email.$dirty) return ''
  if (!v$.value.loginData.email.required) return 'Required'
  if (!v$.value.loginData.email.email) return 'Invalid email format'
  return ''
})

async function submitForm() {
  v$.value.$touch()
  if (v$.value.$invalid) {
    errorMessage.value = 'Please fix the form errors before submitting.'
    return
  }
  store.login()  
}

onMounted(() => {
    cartStore.loadCart()
    
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)
})
</script>
